<template>
  <div>
        <base-navigation></base-navigation>

<div class="dashboard">

  <h2 class="page-title">RaiseTrack Investor Dashboard</h2>

  <!-- BIG BALANCE CARD -->
  <div class="balance-card">
      <h3>Available Balance</h3>
      <h1>{{ currency(availableBalance) }}</h1>
      <p>Current liquidity available for lending</p>
  </div>


  <!-- SUMMARY CARDS -->
  <div class="stats-grid">

      <div class="card invest">
        <h4>Total Investments</h4>
        <p>{{ currency(totalInvestments) }}</p>
      </div>

      <div class="card loans">
        <h4>Loans Disbursed</h4>
        <p>{{ currency(totalLoans) }}</p>
      </div>

      <div class="card repay">
        <h4>Loan Repayments</h4>
        <p>{{ currency(totalRepayments) }}</p>
      </div>

      <div class="card expenses">
        <h4>Total Expenses</h4>
        <p>{{ currency(totalExpenses) }}</p>
      </div>

  </div>


  <!-- EXTRA METRICS -->
  <div class="metrics">

      <div class="metric">
        <h5>Total Loans</h5>
        <p>{{ loans.length }}</p>
      </div>

      <div class="metric">
        <h5>Total Investors</h5>
        <p>{{ investments.length }}</p>
      </div>

      <div class="metric">
        <h5>Repayment Ratio</h5>
        <p>{{ repaymentRatio }}%</p>
      </div>

  </div>
  </div>

</div>
</template>

<script>
import axios from "axios"

export default {

data(){
return{
  investments:[],
  expenses:[],
  loans:[],
  repayments:[]
}
},

computed:{

totalInvestments(){
  return this.investments.reduce((t,i)=>t + Number(i.amount),0)
},

totalExpenses(){
  return this.expenses.reduce((t,e)=>t + Number(e.amount),0)
},

totalLoans(){
  return this.loans.reduce((t,l)=>t + Number(l.loan_amount),0)
},

totalRepayments(){
  return this.repayments.reduce((t,r)=>t + Number(r.TransAmount),0)
},

availableBalance(){
  return this.totalInvestments +
         this.totalRepayments -
         this.totalLoans -
         this.totalExpenses
},

repaymentRatio(){

  if(this.totalLoans === 0) return 0

  return ((this.totalRepayments / this.totalLoans) * 100).toFixed(1)
}

},

methods:{

async loadDashboard(){

try{

const investments = await axios.get("https://api.roberms.com/raisetrack/get/investments")
const expenses = await axios.get("https://api.roberms.com/raisetrack/get/expenses")
const loans = await axios.get("https://api.roberms.com/raisetrack/get/loans")
const repayments = await axios.get("https://api.roberms.com/raisetrack/get/loan/payments")

this.investments = investments.data
this.expenses = expenses.data
this.loans = loans.data
this.repayments = repayments.data

}catch(e){
console.log(e)
}

},

currency(value){
return new Intl.NumberFormat("en-KE",{
style:"currency",
currency:"KES"
}).format(value)
}

},

mounted(){
this.loadDashboard()
}

}
</script>

<style scoped>

.dashboard{
padding:30px;
background:#f5f7fb;
min-height:100vh;
}

.page-title{
margin-bottom:25px;
font-weight:600;
color:#333;
}

/* BALANCE CARD */

.balance-card{
background:linear-gradient(135deg,#1abc9c,#16a085);
color:white;
padding:35px;
border-radius:14px;
margin-bottom:30px;
box-shadow:0 10px 25px rgba(0,0,0,0.15);
}

.balance-card h1{
font-size:42px;
margin:10px 0;
}


/* STATS GRID */

.stats-grid{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(220px,1fr));
gap:20px;
margin-bottom:30px;
}

.card{
padding:25px;
border-radius:12px;
color:white;
font-weight:500;
box-shadow:0 6px 16px rgba(0,0,0,0.1);
transition:0.3s;
}

.card:hover{
transform:translateY(-5px);
}

.invest{
background:linear-gradient(120deg,#3498db,#2980b9);
}

.loans{
background:linear-gradient(120deg,#9b59b6,#8e44ad);
}

.repay{
background:linear-gradient(120deg,#f39c12,#d68910);
}

.expenses{
background:linear-gradient(120deg,#e74c3c,#c0392b);
}


/* METRICS */

.metrics{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(200px,1fr));
gap:20px;
}

.metric{
background:white;
padding:25px;
border-radius:10px;
box-shadow:0 4px 10px rgba(0,0,0,0.08);
}

.metric h5{
color:#777;
margin-bottom:5px;
}

.metric p{
font-size:24px;
font-weight:600;
color:#333;
}

</style>